import React from 'react';
import './utils.css';

export function Hyph() {
  return <span className='Hyph'>{' | '}</span>;
}